import type { IProjectReportRepository } from '../repositories/IProjectReportRepository.js';
import type { ReportFormxItem } from '../entities/ProjectReportRowEntity.js';

interface Deps { projectReportRepository: IProjectReportRepository; }

export function createGetProjectFormxDetailBySessionUseCase({ projectReportRepository }: Deps) {
  return async function getProjectFormxDetailBySession(
    orgId: string,
    projectId: string,
  ): Promise<Map<string, ReportFormxItem[]>> {
    return projectReportRepository.getProjectFormxDetailBySession(orgId, projectId);
  };
}
